import Focus from '@shared/types/enums/focus';
import FocusUtils from '@shared/utils/focus';
import GuideChannelRailOverflowContainer from '@components/atoms/container/guideChannelRailOverflowContainer';
import GuideRailFullContainer from '@components/atoms/container/guideRailFullContainer';
import GuideRailLogoContainer from '@components/atoms/container/guideRailLogoContainer';
import GuideRailLogoImage from '@components/atoms/images/guideRailLogoImage';
import GuideChannelRailAndLogoContainer from '@components/atoms/container/guideChannelRailAndLogoContainer';
import MainContext from '@shared/components/utils/context/mainContext';
import RailListContext from '@shared/components/utils/context/railListContext';
import RailProps from '@shared/types/props/rail';
import RegularRail from './regularRail';
import goToChannelGuide from '@shared/actions/channels/goToChannelGuide';
import useKeyboard from '@shared/components/utils/hooks/useKeyboard';
import { useAppDispatch, useAppSelector } from '@shared/store/hooks';
import { useContext, useEffect, useState } from 'react';
import {
  focusSelector,
  pushFocus,
  setFocus,
} from '@shared/store/slices/focus.slice';
import GuideRailLogoImageContainer from '@components/atoms/container/guideRailLogoImageContainer';

function ChannelGuideRail({ list, animation, style }: RailProps) {
  const dispatch = useAppDispatch();
  const { focus: focusSlice } = useAppSelector(focusSelector);
  const mainContext = useContext(MainContext);
  const { setListIndex } = useContext(RailListContext);
  const [canResetStyle, setCanResetStyle] = useState(false);
  const [image, setImage] = useState('');
  const [imageSelected, setImageSelected] = useState(false);

  const { data, id, focus: listFocus } = list;
  const { filter } = mainContext;
  const containerStyle = { animation, style };

  useEffect(() => {
    if (
      FocusUtils.evaluateFocus(parseInt(Focus.CHANNEL_GUIDE_LOGO + '' + id))
    ) {
      setImageSelected(true);
    } else {
      setImageSelected(false);
    }
  }, [focusSlice]);

  useEffect(() => {
    if (canResetStyle) {
      list.setListIndex?.current(0, 0);
      list.resetStyle();
    } else {
      setCanResetStyle(true);
    }
  }, [filter]);

  useKeyboard({
    focus: parseInt(Focus.CHANNEL_GUIDE_LOGO + '' + id),
    keyDownHandler: () => {
      return null;
    },
    keyUpHandler: (key) => {
      switch (key) {
        case 'SELECT':
          goToChannelGuide(list.data[0]);
          break;
        case 'RIGHT':
          dispatch(setFocus([Focus.RAILS_LIST, listFocus]));
          break;
        case 'LEFT':
          dispatch(pushFocus(Focus.MENU));
          break;
        case 'DOWN':
          setListIndex.current(id + 1);
          break;
        case 'UP':
          setListIndex.current(id - 1);
      }
    },
  });

  useEffect(() => {
    if (data.length) {
      if (data[0]?.channel?.logo) {
        setImage(data[0]?.channel?.logo);
      }
    }
  }, [data]);

  const outOfBounds = (focus: string | number, exit?: string | undefined) => {
    setTimeout(() => {
      if (exit === 'LEFT') {
        dispatch(
          setFocus([
            Focus.CHANNEL_GUIDE_LOGO,
            parseInt(Focus.CHANNEL_GUIDE_LOGO + '' + id),
          ])
        );
      }
    });
  };

  return (
    <GuideRailFullContainer>
      <GuideChannelRailOverflowContainer length={data.length}>
        <GuideChannelRailAndLogoContainer {...containerStyle}>
          <MainContext.Provider
            value={{ ...mainContext, hidePreviousItem: true }}
          >
            <RegularRail list={{ ...list, outOfBounds }}></RegularRail>
          </MainContext.Provider>
        </GuideChannelRailAndLogoContainer>
      </GuideChannelRailOverflowContainer>
      <GuideRailLogoContainer
        imageSelected={imageSelected}
        onClick={() => {
          if (list.data.length) goToChannelGuide(list.data[0]);
        }}
      >
        {image ? (
          <GuideRailLogoImageContainer>
            <GuideRailLogoImage src={image}></GuideRailLogoImage>
          </GuideRailLogoImageContainer>
        ) : null}
      </GuideRailLogoContainer>
    </GuideRailFullContainer>
  );
}

export default ChannelGuideRail;
